/* eslint-disable react-hooks/exhaustive-deps */

import { Grid, Checkbox } from '@mui/material';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { TRIP_DATE_PAIRS, calculateDaysBetween, calculateTripDuration } from 'modules/authorizations/utils';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import React, { useState } from 'react';
import {
  updateAuthDestinationTripsBuyer,
  updateAuthDestinationTripsRenter
} from 'modules/authorizations/store/actions/destinationService.actions';
import { getAuthDestinationServices } from 'modules/authorizations/authorizations.actions';
import EditableCard from 'modules/common/editableCard.component';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';
import { RENTAL_CAR_CLASS_IDS, ZERO_GUID } from 'modules/enumerations/enumerationIds';
import { withDateChronology } from 'utilities/dateChronology';

const HouseHuntingTripCard = props => {
  const [isLoading, setIsLoading] = useState(false);

  const { trip, familyMembers, id, hideEdit, addresses = [], enumerations, renter, buyer, type, enforceDateChronology = false } = props;

  const tripTabs = [{ header: 'Trip Summary', order: 1, iconPath: ['fas', 'house'] }];

  const categories = [
    { id: 0, title: 'tripSummary' },
    { id: 1, title: 'airTransport' },
    { id: 2, title: 'hotelBooking' },
    { id: 3, title: 'rentalCar' }];

  let family = familyMembers.map(f => {
    return f.firstName + ' ' + f.lastName;
  });

  const tripTypes = ['One Way', 'Round-Trip'];
  const tripCategories =
    enumerations.tripCategories && enumerations.tripCategories.length > 0
      ? enumerations.tripCategories.filter(s => s.isActive === true)
      : [{ id: ZERO_GUID, title: '' }];

  const tripBooking = ['Self Booked', 'TRC Booking'];

  const rentalCarClassOptions =
    enumerations && enumerations.rentalCarClasses && enumerations.rentalCarClasses.length > 0
      ? enumerations.rentalCarClasses
      : [{ id: ZERO_GUID, title: '' }];

  const parseValueToArray = input => {
    if (!input) return [];
    return Array.isArray(input) ? input : input.split(',');
  };

  const tripSummaries = [
    {
      header: 'Trip Title',
      accessorKey: 'tripName',
      type: 'text',
      required: false,
      value: trip ? trip.tripName : '',
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Trip Category',
      accessorKey: 'tripCategoryId',
      type: 'dropdown-v2',
      options: tripCategories,
      value: trip?.tripCategoryId ?? ZERO_GUID,
      required: true,
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Family Attending',
      accessorKey: 'familyAttending',
      type: 'multi-select',
      options: family,
      required: false,
      value:
        trip && trip.familyAttending && trip.familyAttending.length > 0
          ? parseValueToArray(trip.familyAttending)
          : parseValueToArray(family[0]),
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Journey',
      accessorKey: 'typeOfTrip',
      type: 'dropdown',
      options: tripTypes,
      value: trip?.typeOfTrip ? trip.typeOfTrip : tripTypes[1],
      required: true,
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Origin',
      accessorKey: 'departureAddressId',
      type: 'dropdown-v2',
      options: addresses && addresses.length > 0 ? addresses : [],
      required: false,
      categoryType: 'tripSummary',
      value: trip ? trip.departureAddressId : null,
      tab: 1
    },
    {
      header: 'Destination',
      accessorKey: 'destinationAddressId',
      type: 'dropdown-v2',
      options: addresses && addresses.length > 0 ? addresses : [],
      required: false,
      categoryType: 'tripSummary',
      value: trip ? trip.destinationAddressId : null,
      tab: 1
    },
    {
      header: 'Trip Start Date',
      accessorKey: 'tripStartDate',
      type: 'date',
      required: false,
      value: trip ? trip.tripStartDate : null,
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Trip End Date',
      accessorKey: 'tripEndDate',
      type: 'date',
      required: false,
      value: trip ? trip.tripEndDate : null,
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Total Nights',
      accessorKey: 'tripDuration',
      type: 'number',
      required: false,
      value:
        trip && trip.tripStartDate && trip.tripEndDate ? calculateTripDuration(trip.tripStartDate, trip.tripEndDate, trip.tripDuration) : 0,
      hasDefault: true,
      defaultValue: ({ values }) => calculateDaysBetween(values.tripStartDate, values.tripEndDate),
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Special Needs',
      accessorKey: 'specialNeeds',
      type: 'notes',
      required: false,
      value: trip ? trip.specialNeeds : '',
      categoryType: 'tripSummary',
      tab: 1
    },
    // {
    //   header: 'Notes',
    //   accessorKey: 'notes',
    //   type: 'notes',
    //   required: false,
    //   value: trip ? trip.notes : '',
    //   categoryType: 'tripSummary',
    //   tab: 1
    // },
    {
      header: 'Booking Type',
      accessorKey: 'hasBookingDetails',
      type: 'dropdown',
      options: tripBooking,
      value: trip?.hasBookingDetails ? tripBooking[1] : tripBooking[0],
      required: true,
      categoryType: 'tripSummary',
      tab: 1
    },
    // Air Transport
    {
      header: 'Air Transport',
      accessorKey: 'airTransport',
      type: 'checkbox',
      required: false,
      value: trip ? trip.airTransport : false,
      tab: 1,
      categoryType: 'airTransport',
      Cell: ({ cell }) => <Checkbox name="airTransport" label="Active" checked={cell.row.original.airTransport} disabled={true} />,
      showWhen: () => {
        return trip && trip.hasBookingDetails === tripBooking[1];
      },
      showWhenModal: ({ values }) => {
        return values && values.hasBookingDetails === tripBooking[1];
      }
    },
    {
      header: 'Departure Date',
      accessorKey: 'airTransportDepartureDate',
      type: 'date',
      required: false,
      value: trip ? trip.airTransportDepartureDate : null,
      categoryType: 'airTransport',
      tab: 1,
      showWhen: () => {
        return trip && trip.airTransport === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.airTransport === true;
      }
    },
    {
      header: 'Arrival Date',
      accessorKey: 'airTransportArrivalDate',
      type: 'date',
      required: false,
      value: trip ? trip.airTransportArrivalDate : null,
      categoryType: 'airTransport',
      tab: 1,
      showWhen: () => {
        return trip && trip.airTransport === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.airTransport === true;
      }
    },
    {
      header: 'Return Departure Date',
      accessorKey: 'airTransportReturnDepartureDate',
      type: 'date',
      required: false,
      value: trip ? trip.airTransportReturnDepartureDate : null,
      categoryType: 'airTransport',
      tab: 1,
      showWhen: () => {
        return trip && trip.airTransport === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.airTransport === true;
      }
    },
    {
      header: 'Return Arrival Date',
      accessorKey: 'airTransportReturnArrivalDate',
      type: 'date',
      required: false,
      value: trip ? trip.airTransportReturnArrivalDate : null,
      categoryType: 'airTransport',
      tab: 1,
      showWhen: () => {
        return trip && trip.airTransport === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.airTransport === true;
      }
    },
    // Hotel Booking
    {
      header: 'Hotel Booking',
      accessorKey: 'hotelBooking',
      type: 'checkbox',
      required: false,
      value: trip ? trip.hotelBooking : false,
      categoryType: 'hotelBooking',
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="hotelBooking" label="Active" checked={cell.row.original.hotelBooking} disabled={true} />,
      showWhen: () => {
        return trip && trip.hasBookingDetails === tripBooking[1];
      },
      showWhenModal: ({ values }) => {
        return values && values.hasBookingDetails === tripBooking[1];
      }
    },
    {
      header: 'Hotel Name',
      accessorKey: 'hotelName',
      type: 'text',
      required: false,
      value: trip ? trip.hotelName : '',
      categoryType: 'hotelBooking',
      tab: 1,
      showWhen: () => {
        return trip && trip.hotelBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hotelBooking === true;
      }
    },
    {
      header: 'Hotel Address',
      accessorKey: 'hotelAddressId',
      type: 'dropdown-v2',
      options: addresses && addresses.length > 0 ? addresses : [],
      required: false,
      categoryType: 'hotelBooking',
      value: trip ? trip.hotelAddressId : null,
      tab: 1,
      showWhen: () => {
        return trip && trip.hotelBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hotelBooking === true;
      }
    },
    {
      header: 'Check In',
      accessorKey: 'hotelCheckInDate',
      type: 'date',
      required: false,
      value: trip ? trip.hotelCheckInDate : null,
      categoryType: 'hotelBooking',
      tab: 1,
      showWhen: () => {
        return trip && trip.hotelBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hotelBooking === true;
      }
    },
    {
      header: 'Check Out',
      accessorKey: 'hotelCheckOutDate',
      type: 'date',
      required: false,
      value: trip ? trip.hotelCheckOutDate : null,
      categoryType: 'hotelBooking',
      tab: 1,
      showWhen: () => {
        return trip && trip.hotelBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hotelBooking === true;
      }
    },
    {
      header: 'Duration of Stay',
      accessorKey: 'hotelDurationOfStay',
      type: 'number',
      required: false,
      value:
        trip && trip.hotelCheckInDate && trip.hotelCheckOutDate
          ? calculateTripDuration(trip.hotelCheckInDate, trip.hotelCheckOutDate, trip.hotelDurationOfStay)
          : 0,
      hasDefault: true,
      defaultValue: ({ values }) => calculateDaysBetween(values.hotelCheckInDate, values.hotelCheckOutDate),
      categoryType: 'hotelBooking',
      tab: 1,
      showWhen: () => {
        return trip && trip.hotelBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hotelBooking === true;
      }
    },
    // Rental Car
    {
      header: 'Rental Car',
      accessorKey: 'rentalCarBooking',
      type: 'checkbox',
      required: false,
      value: trip ? trip.rentalCarBooking : false,
      categoryType: 'rentalCar',
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="rentalCarBooking" label="Active" checked={cell.row.original.rentalCarBooking} disabled={true} />,
      showWhen: () => {
        return trip && trip.hasBookingDetails === tripBooking[1];
      },
      showWhenModal: ({ values }) => {
        return values && values.hasBookingDetails === tripBooking[1];
      }
    },

    {
      header: 'Rental Car Class',
      accessorKey: 'rentalCarClassId',
      type: 'dropdown-v2',
      options: rentalCarClassOptions,
      value: trip?.rentalCarClassId ? trip.rentalCarClassId : ZERO_GUID,
      required: true,
      categoryType: 'rentalCar',
      tab: 1,
      showWhen: () => {
        return trip && trip.rentalCarBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.rentalCarBooking === true;
      }
    },
    {
      header: 'Please Specify Rental Car Class',
      accessorKey: 'otherRentalCar',
      type: 'text',
      required: false,
      value: trip ? trip.otherRentalCar : '',
      categoryType: 'rentalCar',
      tab: 1,
      clearWhenHidden: true,
      showWhen: () => {
        return trip && trip.rentalCarBooking === true && isIdEqual(trip.rentalCarClassId, RENTAL_CAR_CLASS_IDS.OTHER);
      },
      showWhenModal: ({ values }) => {
        return values && values.rentalCarBooking === true && isIdEqual(values.rentalCarClassId, RENTAL_CAR_CLASS_IDS.OTHER);
      }
    },
    {
      header: 'Rental Car Start Date',
      accessorKey: 'rentalCarStartDate',
      type: 'date',
      required: false,
      value: trip ? trip.rentalCarStartDate : null,
      categoryType: 'rentalCar',
      tab: 1,
      showWhen: () => {
        return trip && trip.rentalCarBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.rentalCarBooking === true;
      }
    },
    {
      header: 'Rental Car End Date',
      accessorKey: 'rentalCarEndDate',
      type: 'date',
      required: false,
      value: trip ? trip.rentalCarEndDate : null,
      categoryType: 'rentalCar',
      tab: 1,
      showWhen: () => {
        return trip && trip.rentalCarBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.rentalCarBooking === true;
      }
    },
    {
      header: 'Rental Duration',
      accessorKey: 'rentalCarDuration',
      type: 'number',
      required: false,
      value:
        trip && trip.rentalCarStartDate && trip.rentalCarEndDate
          ? calculateTripDuration(trip.rentalCarStartDate, trip.rentalCarEndDate, trip.rentalCarDuration)
          : 0,
      hasDefault: true,
      defaultValue: ({ values }) => calculateDaysBetween(values.rentalCarStartDate, values.rentalCarEndDate),
      categoryType: 'rentalCar',
      tab: 1,
      showWhen: () => {
        return trip && trip.rentalCarBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.rentalCarBooking === true;
      }
    }
  ];

  const updateTripFields = async (tab, values) => {
    setIsLoading(true);

    let newValues = { ...trip };

    newValues.tripName = values.tripName ? values.tripName : '';
    newValues.tripCategoryId = values.tripCategoryId ? values.tripCategoryId : ZERO_GUID;
    newValues.familyAttending = values.familyAttending ? values.familyAttending.join(',') : values.familyAttending;
    newValues.typeOfTrip = values.typeOfTrip ? values.typeOfTrip : '';
    newValues.tripStartDate = values.tripStartDate ? values.tripStartDate : new Date();
    newValues.tripEndDate = values.tripEndDate ? values.tripEndDate : new Date();
    newValues.tripDuration = values.tripDuration ? values.tripDuration : 0;
    newValues.departureAddressId = values.departureAddressId ? values.departureAddressId : 0;
    newValues.destinationAddressId = values.destinationAddressId ? values.destinationAddressId : 0;
    newValues.specialNeeds = values.specialNeeds ? values.specialNeeds : '';
    newValues.notes = values.notes ? values.notes : '';

    if (values.hasBookingDetails && values.hasBookingDetails === tripBooking[0]) {
      newValues.hasBookingDetails = false;
    } else {
      newValues.hasBookingDetails = true;
    }

    newValues.airTransport = values.airTransport;
    newValues.airTransportDepartureDate = values.airTransportDepartureDate;
    newValues.airTransportArrivalDate = values.airTransportArrivalDate;
    newValues.airTransportReturnDepartureDate = values.airTransportReturnDepartureDate;
    newValues.airTransportReturnArrivalDate = values.airTransportReturnArrivalDate;

    newValues.hotelBooking = values.hotelBooking;
    newValues.hotelName = values.hotelName;
    newValues.hotelAddressId = values.hotelAddressId;
    newValues.hotelCheckInDate = values.hotelCheckInDate;
    newValues.hotelCheckOutDate = values.hotelCheckOutDate;
    newValues.hotelDurationOfStay = values.hotelDurationOfStay;

    newValues.rentalCarBooking = values.rentalCarBooking;
    newValues.rentalCarClassId = values.rentalCarClassId;
    newValues.otherRentalCar = isIdEqual(values.rentalCarClassId, RENTAL_CAR_CLASS_IDS.OTHER) ? values.otherRentalCar : '';
    newValues.rentalCarStartDate = values.rentalCarStartDate;
    newValues.rentalCarEndDate = values.rentalCarEndDate;
    newValues.rentalCarDuration = values.rentalCarDuration;
    newValues.addedBy = values.addedBy ? values.addedBy : 0;
    newValues.addedOn = values.addedOn ? values.addedOn : new Date();
    newValues.modifiedBy = 0;
    newValues.modifiedOn = new Date();

    try {
      const resp =
        type === 'Renter'
          ? await props.updateAuthDestinationTripsRenter(renter?.renter.renterServiceId, newValues)
          : await props.updateAuthDestinationTripsBuyer(buyer?.buyerServiceId, newValues);

      // A failed API call resolves to a FAILURE action instead of throwing. Returning false keeps the edit modal open and
      // EditableCard shows its save-failed toast.
      if (resp?.type?.endsWith('_FAILURE')) {
        setIsLoading(false);
        return false;
      }

      await props.getAuthDestinationServices(id);

      setIsLoading(false);
      return true;
    } catch (e) {
      props.showToast('Unexpected error saving trip.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    }
  };

  return (
    <div>
      <Grid item sx={{ marginBottom: '10px' }}>
        <EditableCard
          tabs={tripTabs}
          summaries={enforceDateChronology ? withDateChronology(tripSummaries, TRIP_DATE_PAIRS) : tripSummaries}
          numColumns={5}
          updateFields={updateTripFields}
          isLoading={isLoading}
          hideEdit={hideEdit}
          categories={categories}
        />
      </Grid>
    </div>
  );
};

const mapStateToProps = state => ({});

export default compose(
  connect(mapStateToProps, {
    updateAuthDestinationTripsRenter,
    updateAuthDestinationTripsBuyer,
    showToast,
    getAuthDestinationServices
  })
)(HouseHuntingTripCard);
